import numeral from 'numeral';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as SalesActions from '../redux/SalesActions';

class balanceSale extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  calculate = (props) => {
    let { Sales } = props;
    var priceArray = [];
    var buyPriceArray = [];
    var receiptArray = [];
    var operatorArray = [];

    var sumFunction = function (a, b) {
      return (Number(a) + Number(b)).toFixed(2);
    };

    //Total Sales
    Sales.flights.map((flight) => {
      priceArray.push(flight.price);
      buyPriceArray.push(flight.buyprice);
    });

    //Total Lodgings
    Sales.lodgings.map((lodging) => {
      lodging.rooms.map((room) => {
        room.options.map((option) => {
          priceArray.push(option.saleCost);
          buyPriceArray.push(option.purchaseCost);
        });
      });
    });

    //Total Other services
    Sales.otherServicesSale.map((otherService) => {
      priceArray.push(otherService.price);
      buyPriceArray.push(otherService.buyprice);
    });

    //Total Other services
    Sales.packages.map((service) => {
      priceArray.push(service.price);
      buyPriceArray.push(service.buyprice);
    });

    //Total Receipts
    Sales.receipts.map((receipt) => {
      if (
        (receipt && receipt.cancel === false) ||
        receipt.cancel === undefined
      ) {
        if (
          receipt &&
          receipt.conceptsArray &&
          receipt.conceptsArray.length > 0
        ) {
          receipt.conceptsArray.map((item) => {
            receiptArray.push(item.amount);
          });
        } else {
          receiptArray.push(receipt.amount);
        }
      }
    });

    //Total OperatorsPayment
    Sales.operatorsPaymentSale.map((paymentOperator) => {
      operatorArray.push(paymentOperator.nationalCurrency);
    });

    var totalPrice = priceArray.length > 0 ? priceArray.reduce(sumFunction) : 0;
    var totalBuyPrice =
      buyPriceArray.length > 0 ? buyPriceArray.reduce(sumFunction) : 0;
    var totalReceipt =
      receiptArray.length > 0 ? receiptArray.reduce(sumFunction) - 0 : 0;

    var totalDebit =
      numeral(totalPrice - 0 - (totalReceipt - 0)).format('0.00') - 0;
    //Bandera para saber si adeuda
    let debitFlag = totalDebit ? false : true;

    var totalOperator =
      operatorArray.length > 0 ? operatorArray.reduce(sumFunction) : 0;

    var type = Sales.type === undefined ? 'sale' : Sales.type;
    if (type === 'sale') {
      if (Number(totalPrice) > 0 && Number(totalDebit) <= 0) {
        type = 'invoice';
      } else {
        type = 'sale';
      }
    }

    var newState = immutable.set(Sales, 'balance.totalPrice', totalPrice);
    newState = immutable.set(newState, 'balance.totalBuyPrice', totalBuyPrice);
    newState = immutable.set(newState, 'balance.totalReceipt', totalReceipt);
    newState = immutable.set(newState, 'balance.totalDebit', totalDebit);
    newState = immutable.set(newState, 'balance.totalOperator', totalOperator);
    newState = immutable.set(newState, 'type', type);

    if (Number(totalDebit) > 0 || Number(totalPrice) === 0) {
      if (newState.dateSaleNote !== undefined) {
        newState = immutable.del(newState, 'dateSaleNote');
      }
    }

    if (
      JSON.stringify(this.props.Sales.balance) !==
        JSON.stringify(newState.balance) ||
      this.props.Sales.dateSaleNote !== newState.dateSaleNote
    )
      props.dispatch(SalesActions.setState(newState));
  };

  componentWillMount() {
    this.calculate(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.calculate(nextProps);
  }

  render() {
    let { Sales } = this.props;
    return (
      <div>
        <h6>Total</h6>
        <h2 style={{ marginTop: 15 }}>
          {numeral(Sales.balance.totalPrice).format('$0,0.00')}
        </h2>
        <h6>Pagado</h6>
        <h4 style={{ marginTop: 15 }}>
          {' '}
          {numeral(Sales.balance.totalReceipt).format('$0,0.00')}
        </h4>
        <h6>Adeudo</h6>
        <h4 style={{ marginTop: 15 }}>
          {numeral(Sales.balance.totalDebit).format('$0,0.00')}
        </h4>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(balanceSale);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/balanceSale.js